var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyCredits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 11.6665C9.42549 11.6665 11.6641 9.42793 11.6641 6.6665C11.6641 3.90508 9.42549 1.6665 6.66406 1.6665C3.90264 1.6665 1.66406 3.90508 1.66406 6.6665C1.66406 9.42793 3.90264 11.6665 6.66406 11.6665Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0755 8.6416C15.8633 8.93529 16.5643 9.42288 17.1136 10.0593C17.663 10.6957 18.0431 11.4603 18.2186 12.2825C18.3942 13.1047 18.3596 13.9579 18.1181 14.7631C17.8765 15.5684 17.4358 16.2998 16.8367 16.8896C16.2376 17.4794 15.4995 17.9087 14.6905 18.1376C13.8816 18.3666 13.0279 18.3879 12.2086 18.1995C11.3892 18.0111 10.6306 17.6192 10.0029 17.0599C9.37514 16.5007 8.89855 15.7922 8.61719 14.9999",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83594 5H6.66927V8.33333",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9229 11.5669L14.5062 12.1586L12.1562 14.5086",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCredits);
export default __webpack_public_path__ + "static/media/Buy Credits.e1d29401a655a4bdeeb58ea707fc65f0.svg";
export { ForwardRef as ReactComponent };